import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../hooks/useCart';

export const ServiceCard = ({ service, index }) => {
  const [inCart, setInCart] = useState(false);
  const { cart, addToCart, removeItem, checkItemInCart } = useCart();

  const handleCart = () => {
    addToCart({ ...service, id: index });
  };

  useEffect(() => {
    if (cart) {
      setInCart(checkItemInCart(index));
    }
  }, [cart]);

  return (
    <div className='product-card' key={index}>
      <div className='product-card__image'>
        {service.badge && (
          <span className='product-card__badge'>{service.badge}</span>
        )}
        <img
          src={service.cover}
          alt={service.title}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </div>
      <div className='product-card__body'>
        <h3 className='product-card__title'>
          <Link to={`/services/${service.slug}`}>{service.title}</Link>
        </h3>
        <p className='product-card__desc'>{service.descrition}</p>
        {service.tags && (
          <div className='product-card__tags'>
            {service.tags.map((tag, i) => (
              <span className='product-tag' key={i}>
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
      <div className='product-card__footer'>
        <span className='product-card__price'>
          ${Number(service.price).toFixed(2)}
        </span>
        {inCart ? (
          <div className='product-card__cart-actions'>
            <button
              className='product-card__btn product-card__btn--remove'
              onClick={() => removeItem(index)}
            >
              Remove
            </button>
            <Link
              to='/cart'
              className='product-card__btn product-card__btn--go'
            >
              Go to Cart
            </Link>
          </div>
        ) : (
          <button
            className='product-card__btn product-card__btn--add'
            onClick={handleCart}
          >
            Add to Cart
          </button>
        )}
      </div>
    </div>
  );
};
